import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { AgendaScrollButtons } from './AgendaScrollButtons';
import styles from './AgendaTitle.module.scss';

export const AgendaTitle = ({
    tabRef,
}: {
    tabRef: React.RefObject<HTMLDivElement>;
}) => {
    return (
        <div className={styles.agendaTitle}>
            <span>{gettext('Agenda')}</span>
            <AgendaScrollButtons tabRef={tabRef} />
        </div>
    );
};
